import { memo, useCallback, useMemo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

import { DAMAGE_PIN_COLUMNS } from "./consts";
import { DamagePinRow, DamagePinTableProps } from "./types";

/**
 * Popis označenih šteta. Tablica je preko cijele širine koraka jer redak nosi i naziv
 * i opis i fotografiju — u uskom stupcu se to nije dalo pročitati.
 */
const DamagePinTable: React.FC<DamagePinTableProps> = (props) => {
  const { pins, photos, statuses, activePin, onPinSelect, onPinEdit, onPinDelete } =
    props;

  const rows: DamagePinRow[] = useMemo(
    () =>
      pins.map((pin) => {
        const status = statuses.find(
          (s) => s.id === pin.vehicleDamageStatusId
        );
        const photo = photos.find((p) => p.id === pin.uploadId);

        return {
          id: pin.tempId,
          name: pin.name,
          description: pin.description,
          statusName: status?.name ?? null,
          statusColor: status?.color ?? null,
          photoName: photo?.originalFileName ?? null,
          photoUrl: photo?.url ?? null,
          isActive: activePin === pin.tempId,
          pin,
        };
      }),
    [pins, photos, statuses, activePin]
  );

  // Klik na redak bira štetu i prebacuje preglednik na njezinu fotografiju.
  const handleRowClick = useCallback(
    (id: string) => {
      const row = rows.find((r) => r.id === id);
      if (row) onPinSelect(row.pin);
    },
    [rows, onPinSelect]
  );

  const handleEditClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>, id: string) => {
      event.stopPropagation();
      event.preventDefault();

      const row = rows.find((r) => r.id === id);
      if (row) onPinEdit(row.pin);
    },
    [rows, onPinEdit]
  );

  const handleDeleteClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>, id: string) => {
      event.stopPropagation();
      event.preventDefault();

      onPinDelete(id);
    },
    [onPinDelete]
  );

  return (
    <TableSearch
      columns={DAMAGE_PIN_COLUMNS(handleEditClick, handleDeleteClick)}
      data={rows}
      selectableRows={false}
      disablePagination={true}
      onRowClick={handleRowClick}
    />
  );
};

export default memo(DamagePinTable);
